import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import get from 'lodash/get';

import Notification from './Notification';

import {
  dismissNotification,
  pinNotification,
} from '../../actions/notifications';

import './styles.css';

const notifDuration = 10000;
let interval;

class UnconnectedNotificationList extends Component {
  componentDidMount() {
    interval = setInterval(this.dismissExpired, 1000);
  }
  componentWillUnmount() {
    clearInterval(interval);
  }
  dismissExpired = () => {
    const { notifications } = this.props;
    const now = new Date();
    notifications.filter(notification => (notification.visible)).forEach((notification) => {
      if (notification.createDate <= now - notifDuration && !notification.pinned) {
        this.props.dismissNotification(notification.id);
      }
    });
  }
  render() {
    const { notifications } = this.props;
    return (
      <div styleName="notifList">
        {notifications.map(notification =>
          (notification.visible ? <Notification
            key={notification.id}
            id={notification.id}
            component={notification.component}
            message={notification.message}
            expanded={notification.pinned}
            onDismissClick={() => this.props.dismissNotification(notification.id)}
            onNotificationPin={() => this.props.pinNotification(notification.id)}
          /> : null))}
      </div>);
  }
}

UnconnectedNotificationList.propTypes = {
  notifications: PropTypes.arrayOf(PropTypes.shape({})),
};

UnconnectedNotificationList.defaultProps = {
  notifications: [{}],
};

const mapStateToProps = state => ({
  notifications: get(state, 'notifications', []),
});

const mapDispatchToProps = {
  dismissNotification,
  pinNotification,
};


export default connect(mapStateToProps, mapDispatchToProps)(UnconnectedNotificationList);



// WEBPACK FOOTER //
// ./src/components/Notifications/index.js